/* eslint-disable no-shadow */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  SpForm,
} from 'components/DesignKit';

import {
  notificationActions,
  businessActions,
} from 'store/actions';
import { Card, Col, Row } from 'antd';
import { Img } from 'design';
import Icon from '../../assets/imgs/services-plan-icon.svg';

const AccountSetup = () => {
  const tiles = [
    {
      title: 'NXT Plans',
      subTitle: 'For Businesses',
      url: 'https://www.phone.com/pricing/?_tracking_id=10913',
    },
    {
      title: 'Express Plans',
      subTitle: 'Toll Free Number',
      url: 'https://www.phone.com/express-connect/instant-toll-free-number/?exp.tracking.id=10913',
    },
    {
      title: 'Classic Plans',
      subTitle: 'Metered/Unlimited Options',
      url: 'https://www.phone.com/pricing-classic/?_tracking_id=10913',
    },
  ];

  return (
    <div
      className="mx-auto mt-5 py-3 px-3"
      style={{ height: 'auto' }}
      bodyStyle={{ height: '100%' }}
    >
      <SpForm style={{
        fontSize: '15px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '4px',
      }}
      >
        Business Phone Solutions with
        <Img style={{ width: 22, height: 22 }} src={Icon} alt="icon" /> Phone.com
      </SpForm>
      <SpForm className="mt-1">
        Through our partnership with Phone.com, Swirepay merchants can easily set up and manage all their business phone needs in one place.
        From call management to flexible phone plans, you’ll have everything you need to stay connected and professional.
        Select a plan below to get started today.
      </SpForm>
      <Row gutter={16} className="mt-5">
        {tiles.map((item) => (
          <Col span={5}>
            <Card
              hoverable
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: '12rem', borderRadius: '10px' }}
              onClick={() => window.open(item?.url, '_blank')}
            >
              <SpForm style={{ fontSize: '15px', fontWeight: 'bold' }}>{item?.title}</SpForm>
              <SpForm className="mt-1">
                {item?.subTitle}
              </SpForm>
              <div className="d-flex align-items-center justify-content-center mt-4">
                <Img src={Icon} alt="icon" />
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loading.loading,
  validator: state.loading.validator,
  submitting: state.loading.submitting,
  selectedAccount: state.account.accounts,
  paymentPagesDetails: state.paymentPagesDetails,
  paymentPagesDetailsStatus: state.paymentPagesDetails.paymentPagesDetailsStatus,
  accountSlug: state.accountSlug.content,
});

const mapDispatchToProps = (dispatch) => ({
  setNotification: ({ type, payload }) => dispatch(notificationActions.setNotification({
    type,
    payload,
  })),
  addBusinessSignUp: (gid, param) => dispatch(businessActions.addBusinessSignUp({
    gid,
    param,
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountSetup);
